export const API_ORIGIN = (process.env.REACT_APP_REST_BFF_URL || "").replace(
  /\/graphql\/?$/,
  "",
);
